var map = {
	"./add_to_apple_wallet_cs.svg": 6676,
	"./add_to_apple_wallet_en.svg": 7007,
	"./add_to_google_wallet_cs.svg": 2907,
	"./add_to_google_wallet_en.svg": 684,
	"./arrows_right_darkbg.png": 1887,
	"./arrows_right_lightbg.png": 9521,
	"./bank-id-logo.svg": 5575,
	"./cover.png": 4639,
	"./cover_white_alt.jpg": 4405,
	"./knihovny.cz.png": 8639,
	"./knihovny_cz_banner.png": 1361,
	"./knihovny_cz_banner_en.png": 1375,
	"./logo_praha.png": 3410,
	"./mlp_logo_big.jpg": 5586,
	"./mlp_logo_only_white.svg": 5225,
	"./mlp_logo_search.png": 3798,
	"./mlp_logo_square.svg": 8180,
	"./mlp_logo_vertical.svg": 5239,
	"./mlp_logo_vertical_white.svg": 1761,
	"./mojeid_logo.png": 6876,
	"./old/2fresh.png": 600,
	"./old/cover_book.png": 9017,
	"./old/cover_book_placeholder.png": 1211,
	"./old/cover_cd.png": 5287,
	"./old/cover_dvd.png": 5902,
	"./old/cover_dvd_nodisc.png": 7009,
	"./old/cover_magazine.png": 5836,
	"./old/ctenari.png": 3822,
	"./old/domu.png": 3563,
	"./old/dotazy.png": 2011,
	"./old/eye-hidden.svg": 5417,
	"./old/eye.svg": 5316,
	"./old/facebook.png": 4602,
	"./old/fajfka_bila.png": 6216,
	"./old/footer_solo.png": 7721,
	"./old/info_tm_seda.png": 6042,
	"./old/knihovna.png": 8606,
	"./old/knihy.png": 7861,
	"./old/logo.png": 8747,
	"./old/logo.svg": 4748,
	"./old/logo_praha.png": 2772,
	"./old/logo_praha_v2.svg": 8006,
	"./old/lupa_bila.png": 6329,
	"./old/lupa_seda.png": 2330,
	"./old/menu_multi.png": 4437,
	"./old/mlp_logo_new.png": 8616,
	"./old/praha_v_kihovne.png": 2596,
	"./old/sipka_s_ocasem_bila.png": 3378,
	"./old/sipka_stranka_dalsi.png": 6471,
	"./old/sipka_stranka_predchozi.png": 2148,
	"./old/sluzby.svg": 5114,
	"./old/telefon_bily.png": 2804,
	"./old/uzivatel.png": 4974,
	"./old/uzivatel_bily.png": 233,
	"./old/vector_icons/facebook.svg": 3063,
	"./old/vector_icons/google-plus.svg": 7767,
	"./old/vector_icons/twitter.svg": 1200,
	"./old/vector_icons/url.svg": 4702,
	"./old/vlevo_seda.png": 1418,
	"./old/vpravo_barevne.png": 466,
	"./old/vpravo_barevne_bile.png": 5913,
	"./old/vpravo_barevne_tmave.png": 9826,
	"./old/vystraha_bila.png": 5357,
	"./old/vystraha_cervena.png": 9617,
	"./old/zavrit.png": 1822,
	"./old/zavrit_light.png": 7183,
	"./old/zpravy.png": 2188,
	"./piktogramy/2017750.JPG": 6284,
	"./piktogramy/2017751.JPG": 7798,
	"./piktogramy/2017752.JPG": 7518,
	"./piktogramy/2017753.JPG": 9451,
	"./piktogramy/2017754.JPG": 9192,
	"./piktogramy/2017756.JPG": 8938,
	"./piktogramy/2017757.JPG": 7847,
	"./piktogramy/2017758.JPG": 1108,
	"./piktogramy/2017759.JPG": 529,
	"./piktogramy/2017760.JPG": 2381,
	"./piktogramy/2017761.JPG": 1936,
	"./piktogramy/2017762.JPG": 7455,
	"./piktogramy/2731905.JPG": 1417,
	"./wallet/gwallet_logo.png": 4110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4210;